<template>
  <v-touch class="week-container">
    <div class="header box-shadow">
      <span class="date">{{calRangeView}}</span>
      <h2>{{ $t('calendars.week_plan_and_note.week_plan')}}</h2>
      <v-touch @tap="close" class="close">
        <div class="font-large close-tap"><span class="icon-cross2 pointer"></span></div>
      </v-touch>
    </div>
    <div class="container" :style="{height: height + 'px'}">
      <div class="body">
        <weekplan
          class="weekplan-container"
          :calId="calId"
          :date="date"
          :events="events"
          :weeknote="weeknote">
        </weekplan>
      </div>
    </div>
  </v-touch>
</template>

<script>
  import moment from 'moment'
  import weekplan from '../WeekPlan/WeekPlan.vue'

  export default {
    components: {weekplan},
    props: ['calId', 'events', 'date', 'weeknote', 'locale'],
    data () {
      return {
        height: 300
      }
    },
    computed: {
      calRangeView () {
        let s = moment(this.date).isoWeekday(1)
        let e = moment(this.date).isoWeekday(7)
        let start = s.locale(this.locale).format('ll')
        let end = e.locale(this.locale).format('ll')
        return start + ' - ' + end
      }
    },
    methods: {
      onTap (lesson) {
        this.$emit('eventClicked', lesson)
      },
      calculateHeightForCalendar () {
        let windowHeight = window.innerHeight
        this.height = windowHeight - 80 - 55
      },
      close () {
        this.$emit('close')
      }
    },
    mounted () {
      window.addEventListener('resize', () => {
        this.calculateHeightForCalendar()
      })
      this.calculateHeightForCalendar()
    }
  }
</script>

<style scoped>
  .week-container {
    -webkit-overflow-scrolling: touch;
  }

  .header {
    position: fixed;
    z-index: 5000;
    padding: 20px;
    height: 80px;
    background: white;
    top: 0;
    right: 0;
    left: 0;
  }

  .close {
    position: fixed;
    right: 0;
    top: 0;
    padding: 20px;
  }

  .container {
    position: fixed;
    overflow-y: scroll;
    top: 80px;
    bottom: 55px;
    left: 0;
    right: 0;
    z-index: 100;
    background: #ffffff;
    display: flex;
    width: 100%;
  }

  .body {
    padding: 10px;
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// Container.vue?5d90b3c9